export default __webpack_public_path__ + "static/media/vitor.a90c70e2.jpeg";